import { createResourceCollection } from '@/request'
import { ResourceModel } from '@/request/types'
import { SeasonalRateSummary } from '@/types'

/**
 * Seasonal (month × hour × day-type × tier) rate breakdown for an arbitrary plan, used to render
 * the admin Bill Extraction tool's TOU rate preview.
 *
 * API endpoint: GET /api/admin/plans/{plan_id}/seasonal_rate_summary/ (resolves any plan, including
 * the custom plans the bill flow builds). The path is passed per-fetch, so there's no fixed
 * apiConfig.path. Rows have no natural id, so computedId derives a collision-proof one; consumers
 * (DailyTOURateOverview) filter by month/weekend and sort by hour, so row order doesn't matter.
 */
export type AdminPlanSeasonalRateResource = SeasonalRateSummary & ResourceModel

export const adminPlanSeasonalRateSummaryCollection =
  createResourceCollection<AdminPlanSeasonalRateResource>({
    name: 'adminPlanSeasonalRateSummary',
    computedId: (data) =>
      `${data.month}-${data.weekend}-${data.tier}-${
        data.centered_rate_index
      }-${(data.hours ?? []).join('.')}`,
    selector: (state) => state.adminPlanSeasonalRateSummary,
  })

export const adminPlanSeasonalRateSummaryReducer =
  adminPlanSeasonalRateSummaryCollection.slice.reducer
